import Vue from "vue";
import VueRouter from "vue-router";
import RouterPrefetch from 'vue-router-prefetch'
import App from "./App";
// TIP: change to import router from "./router/starterRouter"; to start with a clean layout
import router from "./router/index";

import Auth from './auth';
import Api from './api';

import BlackDashboard from "./plugins/blackDashboard";
import i18n from "./i18n"
//import './registerServiceWorker'
Vue.use(BlackDashboard);
Vue.use(VueRouter);
Vue.use(RouterPrefetch);

/* eslint-disable no-new */
new Vue({
  router,
  i18n,
  render: h => h(App),
  data : {
    loggedUser: null
  },
  methods: {
    getLoggedUser() {
      return this.loggedUser;
    },
    setLoggedUser(loggedUser) {
        this.loggedUser = loggedUser;
        Auth.setLoggedUser(loggedUser);
    },
    deleteLoggedUser() {
      this.loggedUser = null;
      Auth.deleteLoggedUser();
    },
    logout() {
      Api.send("POST", "/user/logout", {})
      .then(() => {
        this.deleteLoggedUser();
        this.$router.push({name: 'login'})
      })
      .catch((err) => {
        alert(err.msg);
        this.deleteLoggedUser();
        this.$router.push({name: 'login'})
      });
    },
    canUserDo (actions) {
      return Auth.canUserDo(actions, this.loggedUser);
    }
  },
  mounted() {
    this.loggedUser = Auth.getLoggedUser();
  }
}).$mount("#app");
